import GradientLoader from '@ui/loader/gradient-loader';

const HydrateFallback = () => {
  return (
    <div className="flex-column jc-center ai-center height-100-vh">
      <GradientLoader />
    </div>
  );
};

export default HydrateFallback;
